(function () {
  var sectionStates = new WeakMap();
  var trackedSections = new Set();
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pauseVideo(video, state) {
    if (!video || video.paused) return;
    if (state) {
      state.programmaticPause = true;
    }
    video.pause();
    if (state) {
      setTimeout(function () {
        state.programmaticPause = false;
      }, 0);
    }
  }

  function playVideo(video) {
    if (!video || prefersReducedMotion) return;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        // Autoplay may be blocked; swallow to avoid noisy console logs.
      });
    }
  }

  function lazyLoadVideo(video, state) {
    if (!video || state.loaded) return;
    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) {
      state.loaded = true;
      return;
    }

    sources.forEach(function (source) {
      if (!source.getAttribute('src')) {
        source.setAttribute('src', source.getAttribute('data-src'));
      }
    });

    state.loaded = true;
    video.load();
  }

  function initSection(section) {
    if (!section || sectionStates.has(section)) return;

    var video = section.querySelector('.maxcalm26-video-circle-overlay__video');
    if (!video) return;

    var replayButton = section.querySelector('[data-maxcalm26-circle-video-replay]');
    var pauseButton = section.querySelector('[data-maxcalm26-circle-video-pause]');
    var state = {
      loaded: false,
      intersects: false,
      hasEnded: false,
      startedOnce: false,
      pausedByUser: false,
      programmaticPause: false,
      io: null
    };

    function hideReplayButton() {
      if (!replayButton) return;
      replayButton.hidden = true;
    }

    function showReplayButton() {
      if (!replayButton) return;
      replayButton.hidden = false;
    }

    function hidePauseButton() {
      if (!pauseButton) return;
      pauseButton.hidden = true;
    }

    function showPauseButton() {
      if (!pauseButton) return;
      pauseButton.hidden = false;
    }

    function handleIntersect(entries) {
      entries.forEach(function (entry) {
        if (entry.target !== section) return;

        var isVisible = entry.isIntersecting && entry.intersectionRatio > 0;
        var meetsFirstPlayThreshold = entry.isIntersecting && entry.intersectionRatio >= 0.3;
        var canAutoplay = state.startedOnce ? isVisible : meetsFirstPlayThreshold;
        state.intersects = isVisible;

        if (entry.isIntersecting) {
          lazyLoadVideo(video, state);
        }

        if (canAutoplay && (!state.hasEnded || video.currentTime === 0) && !state.pausedByUser) {
          playVideo(video);
        } else {
          var shouldShowReplay = state.hasEnded || state.pausedByUser || (!isVisible && (video.currentTime > 0 || video.ended));
          hidePauseButton();
          if (shouldShowReplay) {
            showReplayButton();
          } else {
            hideReplayButton();
          }

          if (!isVisible) {
            state.pausedByUser = false;
          }
          pauseVideo(video, state);
        }
      });
    }

    video.muted = true;
    video.setAttribute('muted', 'muted');
    video.playsInline = true;
    video.setAttribute('playsinline', 'playsinline');
    video.removeAttribute('controls');

    video.addEventListener('play', function () {
      state.hasEnded = false;
      state.startedOnce = true;
      state.pausedByUser = false;
      hideReplayButton();
      showPauseButton();
    });

    video.addEventListener('ended', function () {
      state.hasEnded = true;
      hidePauseButton();
      showReplayButton();
    });

    video.addEventListener('pause', function () {
      hidePauseButton();
      if (state.programmaticPause || video.ended || !state.intersects) return;
      state.pausedByUser = true;
      showReplayButton();
    });

    if (replayButton) {
      replayButton.addEventListener('click', function () {
        if (!state.loaded) {
          lazyLoadVideo(video, state);
        }
        state.hasEnded = false;
        state.pausedByUser = false;
        video.currentTime = 0;
        hideReplayButton();
        playVideo(video);
      });
    }

    if (pauseButton) {
      pauseButton.addEventListener('click', function () {
        if (video.paused || video.ended) return;
        video.pause();
      });
    }

    if ('IntersectionObserver' in window) {
      state.io = new IntersectionObserver(handleIntersect, {
        root: null,
        threshold: [0, 0.01, 0.3],
        rootMargin: '0px'
      });
      state.io.observe(section);
    } else {
      lazyLoadVideo(video, state);
      playVideo(video);
    }

    sectionStates.set(section, state);
    trackedSections.add(section);
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-maxcalm26-video-circle-overlay]');
    sections.forEach(initSection);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) return;
    trackedSections.forEach(function (section) {
      var video = section.querySelector('.maxcalm26-video-circle-overlay__video');
      var state = sectionStates.get(section);
      pauseVideo(video, state);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    if (!section || !section.matches('[data-maxcalm26-video-circle-overlay]')) return;

    var state = sectionStates.get(section);
    if (state && state.io) {
      state.io.disconnect();
    }
    sectionStates.delete(section);
    trackedSections.delete(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });
})();
